import { Alert, Paper, Skeleton, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { PageData } from "../../api/types";
import { highlightPlain } from "../../lib/snippet";

/** DOCX/XLSX documents have no PDF rendition: show the extracted page text with highlights. */
export function TextPageView({
  page,
  loading,
  highlightTerms,
}: {
  page: PageData | undefined;
  loading: boolean;
  highlightTerms: readonly string[];
}) {
  const { t } = useTranslation();
  if (loading) return <Skeleton h={300} />;
  if (!page) return <Alert color="yellow">{t("document.noPdf")}</Alert>;
  const html = highlightPlain(page.text, highlightTerms).replace(/\n/g, "<br/>");
  return (
    <Paper withBorder p="lg">
      <Text size="xs" c="dimmed" mb="sm">
        {t("document.textView")}
      </Text>
      <Text
        style={{ whiteSpace: "pre-wrap", lineHeight: 1.6, fontFamily: "inherit" }}
        // highlightPlain escapes everything except <mark>; newlines become <br/>
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Paper>
  );
}
